import Link from 'next/link';

import { Icon } from 'common/icon';
import clsx from 'clsx';
import styles from './styles.module.css';

interface Props {
  url?: string;
  description: string;
  variant?: 'small' | 'medium';
}

export const SeeMore = ({ url, description, variant = 'medium' }: Props) => {
  const itemClass = clsx({
    [styles.casino_inspections__item_thing_small]: variant === 'small',
    [styles.casino_inspections__item_thing_medium]: variant === 'medium',
  });
  return (
    <Link href={url ?? ''} className={clsx(styles.news__all_link, styles.link)}>
      <div className={itemClass}>
        <p>{description}</p>
      </div>
      <div className={styles.casino_inspections__item_arrow}>
        <Icon.Arrow width={20} height={20} />
      </div>
    </Link>
  );
};
